import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, CircularProgress, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { authService } from '../api';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ text: '', type: '' });
        try {
            await authService.requestPasswordReset(email);
            setMessage({ text: t('forgot_password_success'), type: 'success' });
        } catch (err) {
            setMessage({ text: 'Error al procesar la solicitud.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 112px)' }}>
            <Paper elevation={6} sx={{ p: { xs: 4, md: 6 }, borderRadius: 4, maxWidth: 450, width: '100%', textAlign: 'center', gap: 3, display: 'flex', flexDirection: 'column' }}>
                <Typography variant="h5" fontWeight="bold">{t('forgot_password_title')}</Typography>
                <Typography variant="body2" color="textSecondary">{t('forgot_password_msg')}</Typography>
                
                {message.text && <Alert severity={message.type}>{message.text}</Alert>}
                
                <form onSubmit={handleSubmit}>
                    <TextField
                        label={t('login_email')}
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        sx={{ mb: 3 }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : t('login_button')}
                    </Button>
                </form>
                <Button variant="text" onClick={() => window.history.back()}>
                    Volver al inicio
                </Button>
            </Paper>
        </Box>
    );
};

export default ForgotPassword;